import NotificationService from "../services/NotificationService";
import safeLocalStorage from './SafeLocalStorage';

export type Consent = {
  analytics: boolean;
  functional: boolean;
};

export const isValidCookiesConsentOnActionAndShowMessage = (): boolean => {
  const consent = getGdprConsent();

  if (!consent.analytics || !consent.functional) {
    NotificationService.setMessage({
      message: "You have to accept cookies to access this feature",
      status: false,
    });

    return false;
  }

  return true;
}

export const getGdprConsent = (): Consent => {
  const stored = safeLocalStorage.getItem('gdprConsent');
  if (stored) {
    try {
      return JSON.parse(stored);
    } catch {
      return { analytics: false, functional: false };
    }
  }
  return { analytics: false, functional: false };
};

export const getGdprConsentGivenAt = (): boolean => {
  const consentStr = safeLocalStorage.getItem('gdprConsent');
  const consentDateStr = safeLocalStorage.getItem('gdprConsentGivenAt');

  if (!consentStr || !consentDateStr) {
    return true;
  }

  const consentDate = new Date(consentDateStr);
  const now = new Date();

  const monthsPassed =
    (now.getFullYear() - consentDate.getFullYear()) * 12 +
    (now.getMonth() - consentDate.getMonth());

  //12 months
  if (monthsPassed >= 12) {
    return true;
  } else {
    return false;
  }
}